enum MenuConstants {
  DASHBOARD = 'DASHBOARD',
  PEOPLE_ALL = 'PEOPLE_ALL',
  USERS_ALL = 'USERS_ALL',
  USERS_AND_ACCESS = 'USERS_AND_ACCESS',
  USERS = 'USERS',
  COMPANIES_COMMERCIAL = 'COMPANIES_COMMERCIAL',
  INVITE_REQUESTS = 'INVITE_REQUESTS',
  MACHINES_ALL = 'MACHINES_ALL',
  INVENTORY = 'INVENTORY',
  GATEWAYS = 'GATEWAYS',
  ANALYTICS = 'ANALYTICS',
  DEALER_ACCESS = 'DEALER_ACCESS',
  DEALER_ACCESS_EXTERNAL_LINK = 'DEALER_ACCESS_EXTERNA_LINK',
  LEGAL = 'LEGAL',
  INFORMATION = 'INFORMATION',
  SUPPORT = 'SUPPORT',
  FLEET_SERVICES = 'FLEET_SERVICES',
  CHANGELOG = 'CHANGELOG',
  COMPANY_ACCOUNT = 'COMPANY_ACCOUNT',
  UPGRADE_SUBSCRIPTION = 'UPGRADE_SUBSCRIPTION',
  DATA_EXPORT = 'DATA_EXPORT',
  ACCOUNT = 'ACCOUNT',
  HOW_TO_VIDEOS = 'HOW_TO_VIDEOS',
  LOG_OUT = 'LOG_OUT',
  COMPANY = 'COMPANY',
  USER = 'USER',
  ENABLE_ACCESS_GROUPS = 'ENABLE_ACCESS_GROUPS',
  GREENKEEPER = 'GREENKEEPER',
  GREENKEEPER_HOME = 'GREENKEEPER_HOME',
  GREENKEEPER_TASKS = 'GREENKEEPER_TASKS',
  GREENKEEPER_FAIRWAYS = 'GREENKEEPER_FAIRWAYS',
  GREENKEEPER_LOG_ACTIVITIES = 'GREENKEEPER_LOG_ACTIVITIES',
}

export default MenuConstants;
